const HeaderProfile = () => {
  return <div>HeaderProfile</div>;
};

export default HeaderProfile;
